import React, {Component} from 'react';
import { connect } from 'react-redux';
import Parser from 'html-react-parser';

class ModalContentCarouselItem extends Component {

    render() {
        return (
            <div className="modal-content-carousel-item">
                <img src={Parser(this.props.card)} alt="Bilet"/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(ModalContentCarouselItem);





// WEBPACK FOOTER //
// ./src/SHARED/components/modalcontentcarouselitem/modalcontentcarouselitem.component.js